import {
  NEWS_ALL,
  NEWS_GET,
  NEWS_POST,
  NEWS_PUT,
  NEWS_DELETE,
  NEWS_LOADING,
  NEWS_ERROR,
} from '../type';

import api from '../../utils/functions/api';

export const newsCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: NEWS_LOADING });
    const { data } = await api.post(`${process.env.REACT_APP_API_URL}/news`, {
      ...payload,
      // eslint-disable-next-line comma-dangle
    });
    dispatch({ type: NEWS_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: NEWS_ERROR });
  }
};

export const newsGetAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/news?name=${name}&size=${size}&page=${page}`
    );
    if (status === 200) {
      dispatch({ type: NEWS_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: NEWS_ERROR });
  }
};

export const newsGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/news/${id}`
    );
    if (status === 200) {
      dispatch({ type: NEWS_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: NEWS_ERROR });
  }
};

export const newsPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: NEWS_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/news/${id}`,
      payload
    );
    dispatch({ type: NEWS_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: NEWS_ERROR });
  }
};
export const newsDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: NEWS_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/news/${id}`
    );
    dispatch({ type: NEWS_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: NEWS_ERROR });
  }
};
